import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IGetCodes } from 'src/app/interfaces/codes';
import { UserManagementService } from 'src/app/Services/user-management/user-management.service';

@Component({
  selector: 'app-poweruser-change-status',
  templateUrl: './poweruser-change-status.component.html',
  styleUrls: ['./poweruser-change-status.component.css']
})
export class PoweruserChangeStatusComponent implements OnInit {

  @Input() powerUserId: string;
  @Input() fromStatus: string;
  @Input() name: string;
  @Input() role: string;

  toStatus: string = '';
  comments: string = '';
  statuses:any[] = []; // Your statuses here
  formSubmitted = false;
  
  constructor(
    public activeModal: NgbActiveModal,
    public userService: UserManagementService,
  ) {}
  ngOnInit(): void {
    this.getPowerUserStatus()
  }
  getPowerUserStatus() {
    this.userService.getCodes('POWER_USER_STATUS_TYPE').subscribe(
      (res: any) => {
        console.log(res)
        this.statuses= [...res]
      },
      error => {
        console.log(error)
      }
    )
  }
  onSave(form: NgForm) {
    this.formSubmitted = true;
    if (!form.valid) return;
    const result = {
      toStatus: this.toStatus,
      comments: this.comments,
      // Add any other fields you want to return!
    };
  
    this.activeModal.close(result);
  }

}
